module.exports = __webpack_public_path__ + "static/media/muscleaider-5.ff004cfd.png";